import { Observable, Subject } from 'rxjs';
import { ServerUrlService } from 'src/app/services/server-url.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AsaasService {

  firstLoad = false;
  errorMessage = new Subject<any>();

  constructor(
    private http: HttpClient,
    private serverUrlService: ServerUrlService) {}

  registerUser(body: any) {
    this.http.post(`${this.serverUrlService.getUrl()}/register/asaas-account`, 
    JSON.stringify(body),
    {
      headers: {
        'Content-Type':'application/json'
    }})
    .subscribe(
      (res: any) => {
        if (res) { 
          this.errorMessage.next(res)
        }
    }),
      (err: any) => {
        console.error('error', err)
      }
  }
  public ObservableRes(): Observable<any> {
      return this.errorMessage.asObservable();
  }
}
